import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-pencil" }, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "note"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = ["textContent"]
const _hoisted_6 = { class: "columns" }
const _hoisted_7 = { class: "col threefifths" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["textContent"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", null, "Related links", -1)
const _hoisted_13 = ["^href", "textContent"]
const _hoisted_14 = {
  key: 0,
  class: "col twofifths"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h3", null, "Related shortcut keys", -1)
const _hoisted_16 = { class: "columns" }
const _hoisted_17 = { class: "col half" }

import { computed } from "vue";
import { useStore } from "vuex";
import { Note } from "@/models/note";
import { Shortcut } from "@/models/shortcut";
import { convertMarkdown } from "@/markdown/util/markdown.util";
import { Mutations } from "@/store";
import { useRouter } from "vue-router";
import ShortcutKey from "../shortcut/ShortcutKey.vue";
import { Application } from "@/models/application";


export default /*#__PURE__*/_defineComponent({
  __name: 'Note',
  setup(__props) {

const store = useStore();
const router = useRouter();
const applications = computed<Application[]>(() => store.state.applications);
const notes = computed<Note[]>(() => store.state.notes);
const note = computed<Note>(() => store.state.note);
const shortcuts = computed(() => store.state.shortcuts);

const getNotes = (ids: number[]) =>
  notes.value.filter((n: Note) => ids.includes(n.id));

const parentNote = computed(() =>
  notes.value.find((n: Note) => n.chapters.includes(note.value.id))
);

const parentApp = computed(() =>
  applications.value.find((a: Application) =>
    parentNote.value
      ? (a.features || []).includes(parentNote.value.id)
      : (a.features || []).includes(note.value.id)
  )
);
const getShortcuts = (note: Note): Shortcut[] =>
  shortcuts.value.filter((s: Shortcut) => note.shortcut_keys.includes(s.id));

const edit = () => {
  store.commit(Mutations.SetNote, note.value);
  router.push(`/note/${note.value.id}/edit`);
};
const navigate = (n: Note) => {
  store.commit(Mutations.SetNote, n);
  router.push(`/note/${n.id}`);
};
const navigateApp = (n: Application) => {
  store.commit(Mutations.SetApplication, n);
  router.push(`/application/${n.id}`);
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { class: "buttons" }, [
      _createElementVNode("button", {
        type: "button",
        class: "option",
        onClick: edit
      }, [
        _hoisted_1,
        _createTextVNode(" Edit ")
      ])
    ]),
    (note.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("h2", null, [
            (parentApp.value)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: `/note/${parentApp.value.id}`,
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (navigateApp(parentApp.value)), ["prevent"])),
                  textContent: _toDisplayString(parentApp.value.name)
                }, null, 8, ["to", "textContent"]))
              : _createCommentVNode("", true),
            (parentApp.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, " / "))
              : _createCommentVNode("", true),
            (parentNote.value)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 2,
                  to: `/note/${parentNote.value.id}`,
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (navigate(parentNote.value)), ["prevent"])),
                  textContent: _toDisplayString(parentNote.value.title)
                }, null, 8, ["to", "textContent"]))
              : _createCommentVNode("", true),
            (parentNote.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, " / "))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              textContent: _toDisplayString(note.value.title)
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                innerHTML: _unref(convertMarkdown)(note.value.description)
              }, null, 8, _hoisted_8),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getNotes(note.value.chapters), (n) => {
                return (_openBlock(), _createElementBlock("div", null, [
                  _createElementVNode("h3", {
                    textContent: _toDisplayString(n.title)
                  }, null, 8, _hoisted_9),
                  _createElementVNode("div", {
                    innerHTML: _unref(convertMarkdown)(n.description)
                  }, null, 8, _hoisted_10)
                ]))
              }), 256)),
              (note.value.urls.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(note.value.urls, (url) => {
                        return (_openBlock(), _createElementBlock("li", null, [
                          _createElementVNode("a", {
                            "^href": url.url,
                            textContent: _toDisplayString(url.label)
                          }, null, 8, _hoisted_13)
                        ]))
                      }), 256))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (note.value.shortcut_keys.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("ul", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getShortcuts(note.value), (shortcut) => {
                        return (_openBlock(), _createElementBlock("li", null, [
                          _createVNode(ShortcutKey, { shortcut: shortcut }, null, 8, ["shortcut"])
                        ]))
                      }), 256))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})